// ═══════════════════════════════════════════════════════════════
// frontend/src/pages/CrmForm.tsx
// ═══════════════════════════════════════════════════════════════

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CrmApi } from "../lib/api";

export default function CrmForm() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [form, setForm] = useState({ name: "", contactName: "", email: "", expectedRevenue: "" });

  const mutation = useMutation({
    mutationFn: () => CrmApi.create({
      name: form.name,
      contactName: form.contactName,
      email: form.email,
      expectedRevenue: parseFloat(form.expectedRevenue) || 0,
      stageId: 1,
    }),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: ["crm"] }); navigate("/crm"); },
  });

  return (
    <div className="max-w-lg mx-auto">
      <h1 className="text-2xl font-bold mb-6">New Lead</h1>
      <form onSubmit={(e) => { e.preventDefault(); mutation.mutate(); }} className="bg-white rounded-xl shadow-sm border p-6 space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Title *</label>
          <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none" required />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Contact Name</label>
          <input value={form.contactName} onChange={(e) => setForm({ ...form, contactName: e.target.value })}
            className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
          <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Expected Revenue</label>
          <input type="number" step="0.01" value={form.expectedRevenue}
            onChange={(e) => setForm({ ...form, expectedRevenue: e.target.value })}
            className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none" />
        </div>
        <div className="flex gap-3 pt-2">
          <button type="submit" disabled={mutation.isPending}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">
            {mutation.isPending ? "Saving..." : "Create"}
          </button>
          <button type="button" onClick={() => navigate("/crm")}
            className="px-6 py-2 border rounded-lg hover:bg-gray-50">Cancel</button>
        </div>
      </form>
    </div>
  );
}
